
const state = {
  language:0,//语言切换 1：葡萄牙 2：西班牙
}

const mutations = {
  setLanguage(state,val) {
    state.language = val
  },

}

const actions = {}

export default {
  state,
  mutations,
  actions,
}
